import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-no-data',
    templateUrl: './no-data.component.html',
    styleUrls: ['./no-data.component.css'],
    standalone: false
})
export class NoDataComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject();

    constructor(private translate: TranslateService) { }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}